<main class="outer-container form-outer-container">
  <section class="inner-form-container">
    <h3>
      {{'talent-happy-path.quick-apply.otp-page.password' | translate}}
    </h3>
    <div class="otp-helper-info">
      <p>
        {{'talent-happy-path.quick-apply.otp-page.enter-password' | translate}}
      </p>
    </div>

    <form [formGroup]="passwordForm">
      <mat-form-field class="quick-apply-form-field" aria-label="Password Entry Form">
        <mat-label>{{"talent-happy-path.quick-apply.otp-page.password" | translate}}</mat-label>
      <input matInput
             class="borderless-input"
             id="password"
             [type]="hidePassword ? 'password' : 'text'"
             aria-label="Enter your password"
             formControlName="password"
             autocomplete="current-password"
             autofocus>
        <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        <mat-error>
          {{"talent-happy-path.quick-apply.otp-page.password-invalid" | translate}}
        </mat-error>
      </mat-form-field>
    </form>
  </section>

  <section class="button-container double-button-container">
    <button mat-stroked-button
            id="otp-back-button"
            class="double-custom-button back-button-outlined"
            color="secondary"
            (click)="back()">
      <mat-icon>arrow_back</mat-icon>
      {{"talent-happy-path.quick-apply.back" | translate}}
    </button>
    <button mat-flat-button
            id="otp-submit-button"
            class="double-custom-button continue-button"
            color="primary"
            [disabled]="passwordForm.invalid"
            (click)="continue(passwordForm)">
      <mat-icon>arrow_forward</mat-icon>
      {{"talent-happy-path.quick-apply.continue" | translate}}
    </button>
  </section>
</main>
